import { useCallback } from "react";
import { useToken } from "./useToken.js";
const notAuthenticatedState = {
  isAuthenticated: false,
  currentUser: null,
  userMetadata: null,
  loading: false,
  hasError: false
};
const useReauthenticate = (authImplementation, setAuthProviderState, getCurrentUser) => {
  const getToken = useToken(authImplementation);
  return useCallback(async () => {
    if (authImplementation.loadWhileReauthenticating) {
      setAuthProviderState((oldState) => ({
        ...oldState,
        loading: true
      }));
    }
    try {
      const token = await getToken();
      let currentUser;
      if (token || authImplementation.middlewareAuthEnabled) {
        currentUser = await getCurrentUser();
      }
      if (!currentUser) {
        let loading = false;
        if (authImplementation.clientHasLoaded) {
          loading = !authImplementation.clientHasLoaded();
        }
        setAuthProviderState({
          ...notAuthenticatedState,
          loading,
          client: authImplementation.client
        });
      } else {
        const userMetadata = await authImplementation.getUserMetadata();
        setAuthProviderState((oldState) => ({
          ...oldState,
          userMetadata,
          currentUser,
          isAuthenticated: !!currentUser,
          loading: false,
          client: authImplementation.client
        }));
      }
    } catch (e) {
      setAuthProviderState({
        ...notAuthenticatedState,
        hasError: true,
        error: e
      });
    }
  }, [authImplementation, setAuthProviderState, getToken, getCurrentUser]);
};
export {
  useReauthenticate
};
